import axios from 'axios';
import { setApiKeys, setDashboardMode } from '~/utils/auth';
import { SET_USER_DATA, CLEAR_2FA_STATE } from './action-types';
import request from '~/utils/request';
import { isOfferGeneratorWebsite } from '~/utils/helperFunctions';

const apiURL = `${
  isOfferGeneratorWebsite()
    ? import.meta.env.VITE_APP_OFFER_GENERATOR_BASE_URL
    : import.meta.env.VITE_APP_BASE_URL
}/api/v1/`;

const createTempInstance = (tempToken) => {
  return axios.create({
    headers: { Authorization: `Bearer ${tempToken}` },
  });
};

export const setup2FA = (tempToken) => async () => {
  try {
    const instance = createTempInstance(tempToken);
    const response = await instance.post(`${apiURL}auth/2fa/setup`);
    return { message: 'success', data: response.data };
  } catch (error) {
    return error;
  }
};

export const verifySetup2FA = (code, tempToken) => async (dispatch) => {
  try {
    const instance = createTempInstance(tempToken);
    const response = await instance.post(`${apiURL}auth/2fa/setup/verify`, { code });
    const data = response.data?.data;
    if (data?.token) {
      setApiKeys(data.token, data.refreshToken);
      if (data.user?.isSystemAdmin) setDashboardMode(true);
      dispatch({ type: SET_USER_DATA, payload: data.user });
      return { message: 'success' };
    }
    return { message: 'success' };
  } catch (error) {
    return error;
  }
};

export const verify2FACode = (code, tempToken) => async (dispatch) => {
  try {
    const instance = createTempInstance(tempToken);
    const response = await instance.post(`${apiURL}auth/2fa/verify`, { code });
    const data = response.data?.data;
    if (data?.token) {
      setApiKeys(data.token, data.refreshToken);
      if (data.user?.isSystemAdmin) setDashboardMode(true);
      dispatch({ type: SET_USER_DATA, payload: data.user });
      dispatch({ type: CLEAR_2FA_STATE });
      return { message: 'success' };
    }
    return { message: 'success' };
  } catch (error) {
    return error;
  }
};

export const resend2FACode = (tempToken) => async () => {
  try {
    const instance = createTempInstance(tempToken);
    const response = await instance.post(`${apiURL}auth/2fa/resend`);
    return { message: 'success', data: response.data };
  } catch (error) {
    return error;
  }
};

// For re-verification (user has full tokens in localStorage)
export const reverify2FA = (code) => async (dispatch) => {
  try {
    const response = await request.post('auth/2fa/verify', { code });
    dispatch({ type: CLEAR_2FA_STATE });
    return { message: 'success', data: response.data };
  } catch (error) {
    return error;
  }
};

export const resendReverification = () => async () => {
  try {
    const response = await request.post('auth/2fa/resend');
    return { message: 'success', data: response.data };
  } catch (error) {
    return error;
  }
};

// Admin: fetch 2FA policy config
export const fetchTwoFactorConfig = () => async () => {
  try {
    const response = await request.get('admin/security-settings/2fa');
    return { message: 'success', data: response.data?.data };
  } catch (error) {
    return error;
  }
};

// Admin: update 2FA policy config
export const updateTwoFactorConfig = (config) => async () => {
  try {
    const response = await request.put('admin/security-settings/2fa', config);
    return { message: 'success', data: response.data?.data };
  } catch (error) {
    return error;
  }
};
